const updates = [
  { date: '07-31', title: '流浪地球 3 4K 高清版上线', desc: '科幻巨制最新续作现已支持 4K 画质播放，带来极致视觉体验。', tag: '新片上线', tagColor: 'bg-primary-500/10 text-primary-400' },
  { date: '07-29', title: '悬疑专题片单全面更新', desc: '新增 20 部高分悬疑烧脑影片，深夜观影必备片单一键收藏。', tag: '专题更新', tagColor: 'bg-accent-500/10 text-accent-400' },
  { date: '07-27', title: '播放线路优化升级完成', desc: '新增多条备用线路，深夜高峰期观影更流畅，卡顿率降低 80%。', tag: '系统升级', tagColor: 'bg-secondary-500/10 text-secondary-400' },
  { date: '07-24', title: '经典港片专区正式开放', desc: '周星驰、成龙、王家卫等经典港片全集上线，高清修复版重温黄金时代。', tag: '新片上线', tagColor: 'bg-primary-500/10 text-primary-400' },
  { date: '07-21', title: '移动端观影体验全面提升', desc: '适配最新 iOS 与 Android 系统，手机浏览器观影如丝般顺滑。', tag: '系统升级', tagColor: 'bg-secondary-500/10 text-secondary-400' },
  { date: '07-18', title: '奥斯卡获奖影片专辑上线', desc: '囊括近十年奥斯卡最佳影片及提名作品，影迷必修片单一次集齐。', tag: '专题更新', tagColor: 'bg-accent-500/10 text-accent-400' },
  { date: '07-15', title: '用户推荐功能开放测试', desc: '看完电影可直接提交推荐理由，优秀推荐将入选编辑精选展示。', tag: '功能上新', tagColor: 'bg-primary-500/10 text-primary-400' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-flashlight-fill text-primary-400 text-xs"></i></span>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">最新动态</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">影讯速递</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">夜猫影院最新片源上线、功能更新与活动动态一网打尽</p>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="absolute left-4 top-0 bottom-0 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-5">
            {updates.map((item) => (
              <div key={item.title} className="relative flex items-start gap-4 pl-0 sm:pl-10">
                <div className="hidden sm:flex absolute left-[13px] top-2 w-2.5 h-2.5 rounded-full bg-primary-500 ring-2 ring-background-50"></div>
                <div className="flex-shrink-0 sm:hidden">
                  <span className="w-2 h-2 rounded-full bg-primary-500 inline-block mt-1.5"></span>
                </div>
                <div className="flex-1 p-4 rounded-lg bg-background-100 border border-background-200/50">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs font-medium text-foreground-300 whitespace-nowrap">{item.date}</span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-100 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-400">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}